"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = exports.authorizedAxios = exports.apiConstants = void 0;
var axios_1 = __importDefault(require("axios"));
var models_1 = require("../models");
var BASE_PATH = function (network) {
    if (network == models_1.Network.main) {
        throw Error("Mainnet coming soon");
    }
    else if (network == models_1.Network.goerli) {
        return 'https://www.api.goerli.openbasin.io/datastore';
    }
    else if (network == models_1.Network.mumbai) {
        return 'https://www.api.mumbai.openbasin.io/datastore';
    }
    throw Error("Unrecognized network" + network);
};
exports.apiConstants = {
    endpoints: function (network) {
        var basePath = BASE_PATH(network);
        return {
            basePath: basePath,
            contract: {
                name: 'contract',
                base: basePath + '/contract',
                address: basePath + '/contract/address',
                abi: basePath + '/contract/abi',
                details: basePath + '/contract/details',
            },
            authority: {
                name: 'auth',
                details: basePath + '/auth/details',
                permissions: {
                    bucket: '/auth/bucket/permissions',
                    buckets: '/auth/buckets/permissions',
                    restricted: {
                        bucket: '/auth/restricted/bucket/permissions',
                        buckets: '/auth/restricted/buckets/permissions'
                    }
                }
            },
            standard: {
                name: 'standard',
                standard: basePath + '/standard',
                schema: basePath + '/standard/schema',
                mint: basePath + '/standard/mint',
            },
            standards: {
                name: 'standards',
                all: basePath + '/standards/all/standards',
                allSchemas: basePath + '/standards/all/schemas',
                standards: basePath + '/standards',
                schemas: basePath + '/standards/schemas',
            },
            bucket: {
                name: 'bucket',
                base: basePath + '/bucket',
                bucket: basePath + '/bucket/bucket',
                mint: basePath + '/bucket/mint',
                append: basePath + '/bucket/standards/append',
            },
            buckets: {
                name: 'buckets',
                base: basePath + '/buckets',
                buckets: basePath + '/buckets/buckets',
                all: basePath + '/buckets/all',
            },
            document: {
                name: 'document',
                document: basePath + '/document',
                data: basePath + '/document/data',
                mint: basePath + '/document/mint',
                update: basePath + 'document/update'
            },
            documents: {
                name: 'documents',
                documents: basePath + '/documents',
                data: basePath + '/documents/data',
            },
            owner: {
                name: 'owner',
                base: basePath + '/bucket/owner',
                documents: basePath + '/bucket/owner/documents',
                data: basePath + '/bucket/owner/data',
                documentsInBuckets: basePath + '/buckets/owner/documents',
                dataInBuckets: basePath + '/buckets/owner/data',
            },
            owners: {
                name: 'owners',
                base: basePath + '/bucket/owners',
                documents: basePath + '/bucket/owners/documents',
                data: basePath + '/bucket/owners/data',
                documentsInBuckets: basePath + '/buckets/owners/documents',
                dataInBuckets: basePath + '/buckets/owners/data',
            },
            provider: {
                name: 'provider',
                base: basePath + '/provider'
            },
            minter: {
                name: 'minter',
                base: basePath + '/minter',
                standards: basePath + '/minter/standards',
                schemas: basePath + '/minter/schemas',
                buckets: basePath + '/minter/buckets'
            },
            restricted: {
                name: 'restricted',
                base: basePath + '/restricted',
                bucket: basePath + '/restricted/bucket',
                buckets: basePath + '/restricted/buckets',
                document: basePath + '/restricted/bucket/document',
                data: basePath + '/restricted/bucket/document/data',
                documents: basePath + '/restricted/bucket/documents',
                dataset: basePath + '/restricted/bucket/documents/data',
                mint: {
                    bucket: basePath + '/restricted/bucket/mint',
                    document: basePath + '/restricted/bucket/document/mint',
                }
            }
        };
    }
};
var authorizedAxios = function (credentials) {
    return axios_1.default.create({
        headers: {
            Authorization: "Bearer ".concat(credentials.key),
            'Content-Type': 'application/json'
        },
        params: {
            'provider_id': credentials.id,
            'provider_address': credentials.address
        }
    });
};
exports.authorizedAxios = authorizedAxios;
var endpoints = function (network) { return exports.apiConstants.endpoints(network); };
exports.endpoints = endpoints;
